// const config = {
//   apiBaseUrl: "http://localhost:5000",
// };

// const config = {
//   apiBaseUrl: "https://nong.skoolbridge.host",
// };

const config = {
  apiBaseUrl: "https://dashboard.noonionnogarlic.com", // Your API base URL
};

export const PARTNER_DASHBOARD_URL = "https://partner.noonionnogarlic.com";

export default config;
